import i18next from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'

const options = {
  fallbackLng: 'en',
  detection: {
    // order and from where user language should be detected
    order: ['querystring', 'localStorage', 'navigator'],

    // cache user language on
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

    // keys or params to lookup language from
    lookupQuerystring: 'lang',
    lookupFromPathIndex: 0,
  },
  debug: true,
  // special options for react-i18next
  // learn more: https://react.i18next.com/components/i18next-instance
  react: {
    wait: true,
  },
}

const i18n = i18next

// for browser use xhr backend to load translations and browser lng detector
if (typeof document !== 'undefined') {
  i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
}

// initialize if not already initialized
if (!i18n.isInitialized) {
  i18n
    // pass the i18n instance to the react-i18next components.
    // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
    .use(reactI18nextModule)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init(options)
}

export default i18n



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/i18n/index.js